'use client'

import { usePathname } from 'next/navigation'

/* Suppresses the PUBLIC marketing chrome (HomeTicker, GlobalNav header, SiteFooter) on
   authenticated APP-SHELL routes — surfaces that render their OWN sidebar shell and must not
   be wrapped in the public header/footer. usePathname() resolves during SSR in the App Router,
   so this returns null server-side too (no flash of public chrome). Public pages render
   children normally. Purely route-based (no auth/data dependency).

   Covered = routes that mount their own DashboardShell sidebar:
     /admin/*            — admin panel
     /dashboard/*        — Masjid OS / committee dashboard
     /moderator/dashboard/*
     /volunteer/dashboard/*
   NOT covered (deliberately): /onboard (PUBLIC registration wizard) and /account (authenticated
   but has no own sidebar — it relies on the site header as its only nav frame, so suppressing
   would strand it). Never suppress on public pages. */
const APP_SHELL_PREFIXES = ['/admin', '/dashboard', '/moderator/dashboard', '/volunteer/dashboard']

export default function HideSiteChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const onAppShell = !!pathname && APP_SHELL_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + '/'))
  if (onAppShell) return null
  return <>{children}</>
}
